import { CheckWritingType } from '../../../__generated__/gql/zeus/index.ts';

import { CheckWritingGraderType } from '../types/check-writing.types.ts';

export const mapCheckWritingGraderTypeToBackendType = (type: CheckWritingGraderType): CheckWritingType => {
  const mapping: Record<CheckWritingGraderType, CheckWritingType> = {
    [CheckWritingGraderType.LETTER]: CheckWritingType.LETTER,
  };
  return mapping[type];
};
